import React from 'react';
import { CalendarCheck, MapPin, Clock, User } from 'lucide-react';

const meetings = [
  {
    id: 'mtg-u01',
    contact: 'Sarah Kowalski',
    company: 'Sysco Corp',
    date: 'May 17',
    time: '10:30 AM',
    venue: 'Booth 4421',
    status: 'confirmed',
  },
  {
    id: 'mtg-u02',
    contact: 'Raj Patel',
    company: 'US Foods',
    date: 'May 17',
    time: '2:00 PM',
    venue: 'Meeting Lounge B',
    status: 'confirmed',
  },
  {
    id: 'mtg-u03',
    contact: 'Claire Dubois',
    company: 'Nestlé Professional',
    date: 'May 18',
    time: '9:00 AM',
    venue: 'Booth 3210',
    status: 'tentative',
  },
  {
    id: 'mtg-u04',
    contact: 'Marcus Webb',
    company: 'Gordon Food Service',
    date: 'May 18',
    time: '11:00 AM',
    venue: 'Main Hall Café',
    status: 'confirmed',
  },
];

const statusStyle: Record<string, string> = {
  confirmed: 'bg-emerald-50 text-emerald-700',
  tentative: 'bg-amber-50 text-amber-700',
  requested: 'bg-blue-50 text-blue-700',
};

export default function UpcomingMeetings() {
  return (
    <div className="bg-white rounded-xl border border-border shadow-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <CalendarCheck size={15} className="text-emerald-600" />
          <h2 className="text-sm font-semibold text-foreground">Upcoming Meetings</h2>
        </div>
        <span className="text-[10px] font-mono font-semibold bg-emerald-50 text-emerald-700 px-1.5 py-0.5 rounded">
          {meetings.length} scheduled
        </span>
      </div>
      <div className="space-y-2">
        {meetings.map((m) => (
          <div
            key={m.id}
            className="flex items-start gap-3 p-2.5 rounded-lg border border-border hover:bg-muted/40 transition-colors cursor-pointer"
          >
            <div className="w-9 h-9 rounded-lg bg-primary/8 flex flex-col items-center justify-center shrink-0">
              <span className="text-[9px] font-semibold text-primary">MAY</span>
              <span className="text-xs font-bold text-primary font-mono leading-none">
                {m.date.split(' ')[1]}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1.5 mb-0.5">
                <p className="text-xs font-semibold text-foreground truncate">{m.contact}</p>
                <span className={`badge text-[9px] ${statusStyle[m.status]}`}>{m.status}</span>
              </div>
              <p className="text-[10px] text-muted-foreground flex items-center gap-1 truncate">
                <User size={9} />
                {m.company}
              </p>
              <div className="flex items-center gap-3 mt-1">
                <span className="flex items-center gap-1 text-[10px] text-muted-foreground">
                  <Clock size={9} />
                  {m.time}
                </span>
                <span className="flex items-center gap-1 text-[10px] text-muted-foreground">
                  <MapPin size={9} />
                  {m.venue}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}